// 📁 src/components/AboutUs/PinkHelp.js
import React from "react";

const PinkHelp = () => (
  <>
    {/* Hero Section */}
    <section
      className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(90deg, rgba(252, 53, 236, 1) 0%, rgba(237, 0, 170, 1) 100%)",
      }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        }}
      ></div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik] leading-tight">
          Pink Help
        </h1>
      </div>
    </section>

    {/* Content Section */}
    <div className="max-w-5xl mx-auto py-16 px-6 text-gray-800">
      <h2 className="text-3xl font-extrabold mb-6 text-main-pink">
        The World’s First Women-Focused Global Platform
      </h2>

      <p className="text-base leading-relaxed mb-4">
        <strong>Pink Help</strong> is the official platform of Women of the World, Inc., operating in 250 countries and territories.
        It connects women to trusted, verified services in 10 critical categories, including health, legal, education,
        business, housing, finance, and family support.
      </p>

      <p className="text-base leading-relaxed mb-4">
        Every country has its own Pink Page, allowing women to:
      </p>

      <ul className="list-disc list-inside text-base text-gray-700 mb-6 space-y-1">
        <li>Find help based on their location and needs</li>
        <li>Submit support requests through secure forms</li>
        <li>Access locally and globally verified providers</li>
        <li>Engage with category-specific resources</li>
        <li>Trust that their data is safe, private, and used only to connect them to real help</li>
      </ul>

      <p className="text-base leading-relaxed mb-4">
        <strong>Pink Help</strong> also enables businesses to advertise their services and become exclusive partners in their countries or categories —
        ensuring reach, visibility, and social impact.
      </p>

      <blockquote className="mt-6 text-xl italic text-main-pink font-semibold border-l-4 pl-4 border-main-pink">
        "Help isn't a luxury — it's a right. We're just making it easier to find."
      </blockquote>
    </div>
  </>
);

export default PinkHelp;